@if (this.label(); as label) {
  <ta-label type="default">{{ label | translate }}</ta-label>
}
